import { render } from "./questionOne.vue?vue&type=template&id=27719889"
import script from "./questionOne.vue?vue&type=script&lang=ts"
export * from "./questionOne.vue?vue&type=script&lang=ts"

import "./questionOne.vue?vue&type=style&index=0&id=27719889&lang=css"
script.render = render

export default script